var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-list"},[_vm._v("\n  暂无数据\n")])}
var staticRenderFns = []

export { render, staticRenderFns }